import * as moment from 'moment';

export const unixAdapter = (unixDate) => moment.unix(unixDate).format('DD/MM/YYYY HH:mm A');
